import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ExpenseCalculationCountryDto } from 'src/app/data-transfer/entities/evaluation-entities/expense-calculation-country-dto';

@Component({
  selector: 'app-expense-calculation-parent',
  templateUrl: './expense-calculation-parent.component.html',
  styleUrls: ['./expense-calculation-parent.component.scss']
})
export class ExpenseCalculationParentComponent implements OnDestroy {

  protected packagingPartType!: number;

  protected routeDataSubscription?: Subscription;
  protected routeParamsSubscription?: Subscription;

  protected licenseFeeCountries!: ExpenseCalculationCountryDto[];
  protected ecomodulationCountries!: ExpenseCalculationCountryDto[];
  protected plasticTaxCountries!: ExpenseCalculationCountryDto[];

  ngOnDestroy(): void {
    this.routeDataSubscription?.unsubscribe();
    this.routeParamsSubscription?.unsubscribe();
  }

  getDateTimeString(date?: string) {
    if (date == null) { return; }
    const dateDate = new Date(date);
    return `${dateDate.toLocaleDateString()} ${dateDate.toLocaleTimeString()}`;
  }
}
